import * as React from 'react';
import { currencyFormatter, DateFormat, TimeFormat, dateFormatter } from 'easit--localization';

export interface ICashOutListItemProps {
    betId: number;
    stake: number;
    possiblePayout: number;
    cashOut: number;
    time: Date;
    cashOutDate: Date;
    betType: number;
    currency: string;
    onGoToDetail: (betId: number) => void;
}

export const CashOutListItem: React.FC<ICashOutListItemProps> = (props: ICashOutListItemProps) => {
    const { betId, stake, possiblePayout, cashOut, onGoToDetail, time } = props;
    return (
        <tr onClick={() => { onGoToDetail(betId) }} className="cursor-pointer" data-test-role="cashout-list__item">
            <td className="time-col">
                {dateFormatter.formatDateAsRelative(time, DateFormat.DDMM)}<br />
                {dateFormatter.formatTime(time, TimeFormat.HHMM)}
            </td>
            <td>{currencyFormatter.format(stake/*, currency*/)}</td>
            <td>{currencyFormatter.format(possiblePayout/*, currency*/)}</td>
            <td >{currencyFormatter.format(cashOut/*, currency*/)}<span className="fa fa-angle-right ml-3" ></span></td>
        </tr>
    );
}